var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContractList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5364 5.46155C11.7805 5.70569 11.7805 6.10144 11.5364 6.34546L7.34351 10.5385C7.09937 10.7825 6.70374 10.7825 6.45959 10.5385L4.46362 8.54236C4.21948 8.29834 4.21948 7.90259 4.46362 7.65857C4.70764 7.41443 5.10339 7.41443 5.34741 7.65857L6.90149 9.21265L10.6525 5.46155C10.8966 5.21753 11.2924 5.21753 11.5364 5.46155ZM16 8C16 12.422 12.4214 16 8 16C3.578 16 0 12.4214 0 8C0 3.578 3.57861 0 8 0C12.422 0 16 3.57861 16 8ZM14.75 8C14.75 4.26892 11.7306 1.25 8 1.25C4.26892 1.25 1.25 4.26941 1.25 8C1.25 11.7311 4.26941 14.75 8 14.75C11.7311 14.75 14.75 11.7306 14.75 8Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractList);
export default __webpack_public_path__ + "static/media/contractList.aa0034f6874bf56a7d46666e2f901a7f.svg";
export { ForwardRef as ReactComponent };